import {
  Button,
  Flex,
  GreyGrey80,
  IconBug,
  Primary12SemiBold,
  Switch,
  Text,
  Tooltip
} from '@sequencehq/core-components'
import { FC } from 'react'

import { useDebugMode } from './debugMode'

type DebugModeItemProps = {
  isExpanded: boolean
}

const DEBUG_MODE_TOOLTIP_LABEL = 'Developer logs and inspectors'

/** Dimmed while off, so you can tell at a glance that nothing is turned on. */
const DISABLED_OPACITY = 0.3

export const DebugModeItem: FC<DebugModeItemProps> = ({ isExpanded }) => {
  const [isDebugModeEnabled, setIsDebugModeEnabled] = useDebugMode()

  const bugIcon = (
    <IconBug
      size={isExpanded ? 14 : 16}
      color={GreyGrey80}
      opacity={isDebugModeEnabled ? 1 : DISABLED_OPACITY}
    />
  )

  if (!isExpanded) {
    return (
      <Flex justifyContent="center" width="100%">
        <Tooltip label={DEBUG_MODE_TOOLTIP_LABEL} placement="right" hasArrow>
          <Button
            data-testid="performance-monitor-bar.debugMode.toggle"
            aria-label="Toggle debug mode"
            aria-pressed={isDebugModeEnabled}
            size="24px"
            variant="ghost"
            style={{ minWidth: '24px', height: '24px' }}
            onClick={() => setIsDebugModeEnabled(!isDebugModeEnabled)}
            icon={bugIcon}
          />
        </Tooltip>
      </Flex>
    )
  }

  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      gap="8px"
      paddingX="12px"
      width="100%"
    >
      <Flex alignItems="center" gap="6px">
        <Tooltip label={DEBUG_MODE_TOOLTIP_LABEL} placement="right" hasArrow>
          {bugIcon}
        </Tooltip>
        <Text {...Primary12SemiBold} color={GreyGrey80}>
          Debug mode
        </Text>
      </Flex>
      <Switch
        data-testid="performance-monitor-bar.debugMode.switch"
        aria-label="Toggle debug mode"
        checked={isDebugModeEnabled}
        onChange={setIsDebugModeEnabled}
      />
    </Flex>
  )
}
